import type { NextPage } from 'next'
import Head from 'next/head'

import InheritorsConponent from '@/components/inheritors'

const Inheritors: NextPage = () => {
  return (
    <>
      <Head>
        <title>{'Inherit Wallet - Inheritance Management'}</title>
      </Head>

      <main>
        <InheritorsConponent />
      </main>
    </>
  )
}

export default Inheritors
